import { Injectable } from '@angular/core';

@Injectable()
export class PermissionConstant {
  static ALL = 'ALL';
  static ADD_COMPANY = 'ADD_COMPANY';
  static LIST_COMPANY = 'LIST_COMPANY';
  static ADD_CAREER = 'CAREER_ADD_CAREER';
  static LIST_CAREER = 'CAREER_LIST_CAREER';
  static ADD_BLOG = 'BLOG_ADD_BLOG';
  static LIST_BLOG = 'BLOG_LIST_BLOG';
  static ADD_META_TAG = 'META_TAGS_ADD_META_TAG';
  static LIST_META_TAG = 'META_TAGS_LIST_META_TAG';
  static ADD_CAREER_DATA = 'CAREER_DATA_ADD_CAREER_DATA';
  static LIST_CAREER_DATA = 'CAREER_DATA_LIST_CAREER_DATA';
  static DEPARTMENT_OVERVIEW = 'DEPARTMENT_OVERVIEW';
  static ADD_DEPARTMENT = 'DEPARTMENT_ADD_DEPARTMENT';
  static LIST_DEPARTMENT = 'DEPARTMENT_LIST_DEPARTMENT';
  static UPDATE_DEPARTMENT = 'DEPARTMENT_UPDATE_DEPARTMENT';
  static STATUS_DEPARTMENT = 'DEPARTMENT_STATUS_DEPARTMENT';
  static DELETE_DEPARTMENT = 'DEPARTMENT_DELETE_DEPARTMENT';
  static DESIGNATION_OVERVIEW = 'DESIGNATION_OVERVIEW';
  static ADD_DESIGNATION = 'DESIGNATION_ADD_DESIGNATION';
  static LIST_DESIGNATION = 'DESIGNATION_LIST_DESIGNATION';
  static UPDATE_DESIGNATION = 'DESIGNATION_UPDATE_DESIGNATION';
  static STATUS_DESIGNATION = 'DESIGNATION_STATUS_DESIGNATION';
  static DELETE_DESIGNATION = 'DESIGNATION_DELETE_DESIGNATION';
  static DDMAPPING_OVERVIEW = 'DDMAPPING_OVERVIEW_DDMAPPING';
  static ADD_DDMAPPING = 'DDMAPPING_ADD_DDMAPPING';
  static LIST_DDMAPPING = 'DDMAPPING_LIST_DDMAPPING';
  static UPDATE_DDMAPPING = 'DDMAPPING_UPDATE_DDMAPPING';
  static STATUS_DDMAPPING = 'DDMAPPING_STATUS_DDMAPPING';
  static DELETE_DDMAPPING = 'DDMAPPING_DELETE_DDMAPPING';
  static LIST_ATTENDANCE = 'ATTENDANCE_LIST_ATTENDANCE';
  static TODAY_ATTENDANCE = 'ATTENDANCE_TODAY_ATTENDANCE';
  static ADD_ATTENDANCE = 'ATTENDANCE_ADD_ATTENDANCE';
  static ACCESS_OVERVIEW = 'ACCESS_OVERVIEW_ACCESS';
  static ACCESS_ROLES = 'ACCESS_ROLES_ACCESS';
  static ACCESS_PERMISSIONS = 'ACCESS_PERMISSIONS_ACCESS';
  static ADD_PERMISSIONS = 'PERMISSIONS_ADD_PERMISSIONS';
  static LIST_PERMISSIONS = 'PERMISSIONS_LIST_PERMISSIONS';
  static SUB_PERMISSIONS = 'PERMISSIONS_SUB_PERMISSIONS';
  static UPDATE_PERMISSIONS = 'PERMISSIONS_UPDATE_PERMISSIONS';
  static STATUS_PERMISSIONS = 'PERMISSIONS_STATUS_PERMISSIONS';
  static DELETE_PERMISSIONS = 'PERMISSIONS_DELETE_PERMISSIONS';
  static ADD_SUBPERMISSIONS = 'SUBPERMISSIONS_ADD_SUBPERMISSIONS';
  static UPDATE_SUBPERMISSIONS = 'SUBPERMISSIONS_UPDATE_SUBPERMISSIONS';
  static STATUS_SUBPERMISSIONS = 'SUBPERMISSIONS_STATUS_SUBPERMISSIONS';
  static DELETE_SUBPERMISSIONS = 'SUBPERMISSIONS_DELETE_SUBPERMISSIONS';
  static ADD_ROLE = 'ROLE_ADD_ROLE';
  static LIST_ROLE = 'ROLE_LIST_ROLE';
  static UPDATE_ROLE = 'ROLE_UPDATE_ROLE';
  static DELETE_ROLE = 'ROLE_DELETE_ROLE';
  static STATUS_ROLE = 'ROLE_STATUS_ROLE';
  static ROLE_PERMISSION = 'ROLE_PERMISSION';
  static EMPLOYEE_OVERVIEW = 'EMPLOYEE_OVERVIEW_EMPLOYEE';
  static ADD_EMPLOYEE = 'EMPLOYEE_ADD_EMPLOYEE';
  static LIST_EMPLOYEE = 'EMPLOYEE_LIST_EMPLOYEE';
  static EDIT_EMPLOYEE = 'EMPLOYEE_EDIT_EMPLOYEE';
  static STATUS_EMPLOYEE = 'EMPLOYEE_STATUS_EMPLOYEE';
  static DELETE_EMPLOYEE = 'EMPLOYEE_DELETE_EMPLOYEE';
  static ASSIGN_DEVICE = 'EMPLOYEE_ASSIGN_DEVICE_EMPLOYEE';
  static EMPLOYEE_RESIGNATION = 'EMPLOYEE_RESIGNATION_EMPLOYEE';
  static HOLIDAY_OVERVIEW = 'HOLIDAY_OVERVIEW_HOLIDAY';
  static ADD_HOLIDAY = 'HOLIDAY_ADD_HOLIDAY';
  static LIST_HOLIDAY = 'HOLIDAY_LIST_HOLIDAY';
  static EDIT_HOLIDAY = 'HOLIDAY_EDIT_HOLIDAY';
  static DELETE_HOLIDAY = 'HOLIDAY_DELETE_HOLIDAY';
  static ADD_LEAVE = 'LEAVE_ADD_LEAVE';
  static LIST_LEAVE = 'LEAVE_LIST_LEAVE';
  static UPDATE_LEAVE = 'LEAVE_UPDATE_LEAVE';
  static VIEW_LEAVE_DOC = 'LEAVE_VIEW_DOC_LEAVE';
  static PREVIEW_LEAVE_MESSAGE = 'LEAVE_PREVIEW_MESSAGE_LEAVE';
  static LEAVE_STATUS = 'LEAVE_STATUS_LEAVE';
  static DELETE_LEAVE = 'LEAVE_DELETE_LEAVE';
  static ADD_PROFILE = 'PROFILE_ADD_PROFILE';
  static LIST_PROFILE = 'PROFILE_LIST_PROFILE';
  static DEVICE_OVERVIEW = 'DEVICE_OVERVIEW_DEVICE';
  static ADD_DEVICE = 'DEVICE_ADD_DEVICE';
  static LIST_DEVICE = 'DEVICE_LIST_DEVICE';
  static EDIT_DEVICE = 'DEVICE_EDIT_DEVICE';
  static DEVICE_STATUS = 'DEVICE_STATUS_DEVICE';
  static DEVICE_DELETE = 'DEVICE_DELETE_DEVICE';
  static DEVICE_IMAGE_UPLOAD = 'DEVICE_IMAGE_UPLOAD_DEVICE';
  static VIEW_DEVICE_DETAILS = 'DEVICE_VIEW_DETAILS_DEVICE';
  static ADD_TEMPLATE = 'TEMPLATE_ADD_TEMPLATE';
  static LIST_TEMPLATE = 'TEMPLATE_LIST_TEMPLATE';
  static UPDATE_TEMPLATE = 'TEMPLATE_UPDATE_TEMPLATE';
  static TEMPLATE_STATUS = 'TEMPLATE_STATUS_TEMPLATE';
  static DELETE_TEMPLATE = 'TEMPLATE_DELETE_TEMPLATE';
  static ADD_INVOICE = 'INVOICE_ADD_INVOICE';
  static LIST_INVOICE = 'INVOICE_LIST_INVOICE';
  static EDIT_INVOICE = 'INVOICE_EDIT_INVOICE';
  static VIEW_INVOICE = 'INVOICE_VIEW_INVOICE';
  static DELETE_INVOICE = 'INVOICE_DELETE_INVOICE';
  static ADD_PROFORMA_INVOICE = 'PROFORMA_INVOICE_ADD_PROFORMA_INVOICE';
  static LIST_PROFORMA_INVOICE = 'PROFORMA_INVOICE_LIST_PROFORMA_INVOICE';
  static EDIT_PERFORMA = 'PERFORMA_EDIT_PERFORMA';
  static VIEW_PERFORMA = 'PERFORMA_VIEW_PERFORMA';
  static DELETE_PERFORMA = 'PERFORMA_DELETE_PERFORMA';
  static ADD_CHAT = 'CHAT_ADD_CHAT';
  static LIST_CHAT = 'CHAT_LIST_CHAT';
  static COMPLAINTS = 'COMPLAINTS';
  static COMPLAINTS_ADD = 'COMPLAINTS_ADD_COMPLAINTS';
  static COMPLAINTS_UPDATE = 'COMPLAINTS_UPDATE_COMPLAINTS';
  static COMPLAINTS_DELETE = 'COMPLAINTS_DELETE_COMPLAINTS';
  static COMPLAINTS_STATUS = 'COMPLAINTS_STATUS_COMPLAINTS';
  static COMPLAINTS_REVIEW_STATUS = 'COMPLAINTS_REVIEW_STATUS_COMPLAINTS';
}
